// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import Americanexpress from "@steiner/XDL/Icons/Americanexpress";
import Discovery from "@steiner/XDL/Icons/Discovery";
import Mastercard from "@steiner/XDL/Icons/Mastercard";
import Visa from "@steiner/XDL/Icons/Visa";
import { mergeWithCss, xClassNames } from "@steiner/XDL/Utilities";
import React, { FC, useState } from "react";

interface Props {
    selectedCard?: string;
    extendedStyles?: CreditCardTypeStyles;
}

export interface CreditCardTypeStyles {
    container?: InjectableCss;
    icon?: IconPresentationProps;
}

export const creditCardTypeStyles: CreditCardTypeStyles = {};

const CreditCardType: FC<Props> = ({ selectedCard, extendedStyles }) => {
    const [styles] = useState(() => mergeWithCss(creditCardTypeStyles, extendedStyles));

    return (
        <StyledWrapper {...styles.container}>
            <Icon
                {...styles.icon}
                src={Mastercard}
                className={xClassNames.append(selectedCard && selectedCard !== "mastercard" && "disabled")}
            />
            <Icon
                {...styles.icon}
                src={Americanexpress}
                className={xClassNames.append(selectedCard && selectedCard !== "american express" && "disabled")}
            />
            <Icon
                {...styles.icon}
                src={Discovery}
                className={xClassNames.append(selectedCard && selectedCard !== "discovery" && "disabled")}
            />
            <Icon
                {...styles.icon}
                src={Visa}
                className={xClassNames.append(selectedCard && selectedCard !== "visa" && "disabled")}
            />
        </StyledWrapper>
    );
};

export default CreditCardType;
